import React from "react";
import Routes from "./Routes/index";


// Import Scss
import "./assets/scss/theme.scss";

function App() {
  //application avec css et routes pour la gestion de nav
  return (
    <React.Fragment>*
      <Routes />
    </React.Fragment>
  );
}

export default App;
